import React from "react";
import FormSelect from "../FormSelect";

export const MasterAccountTypes = {
    PrivateClient: { label: 'Private Client', value: 0, isDisabled: false }
}

const MasterAccountTypeSelect = ({ options, ...rest }) => {
    return <FormSelect
        options={Object.values(MasterAccountTypes)}
        {...rest}
    />
};

export default MasterAccountTypeSelect;